module.exports = __webpack_public_path__ + "static/media/minus.ac52a507.svg";